module.exports = __webpack_public_path__ + "static/media/coins-tab-active.9b16f242.png";